<template>
    <div v-if="data&&settings" :data-id="data.id" :data-permission-id="data.permission_id">
        <el-dialog
            :title="title"
            width="800px"
            :visible="show"
            :before-close="beforeClose"
            v-loading="processing"
            @close="onCancelClick"
        >
            <h2>{{data.name}}</h2>
            <p>{{data.description}}</p>
            <div class="permission-detail-form">
                <div class="permission-detail-item" v-if="data.display_name">
                    <div class="title">
                        <span>Name</span>
                    </div>
                    <div class="value">
                        <span>{{data.display_name}}</span>
                    </div>
                </div>
                <div class="permission-detail-item" v-if="data.email">
                    <div class="title">
                        <span>Email</span>
                    </div>
                    <div class="value">
                        <span>{{data.email}}</span>
                    </div>
                </div>
                <h2>Permission Settings</h2>
                <div class="permission-detail-form-settings">
                    <div
                        class="permission-detail-item"
                        v-for="(permission, idx) in permissions"
                        :key="idx"
                    >
                        <div class="title">
                            <span>{{permission.name}}</span>
                        </div>
                        <div class="value">
                            <div
                                class="permission-detail-item"
                                v-for="(setting, setting_idx) in permission.value"
                                :key="setting_idx"
                            >
                                <div class="title" v-if="permission.value.length > 1">
                                    <span>{{setting.name}}</span>
                                </div>
                                <div class="value">
                                    <div
                                        class="permission-detail-item"
                                        v-for="(set, set_idx) in setting.value"
                                        :key="set_idx"
                                    >
                                        <div class="title">
                                            <span>{{set.name}}</span>
                                        </div>
                                        <div class="value">
                                            <span>
                                                <el-switch v-model="set.value" disabled></el-switch>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onDelete" type="danger">
                    <i class="el-icon-delete"></i> Remove Permission
                </el-button>
            </div>
        </el-dialog>
        <PermissionNew :show="showEdit" :onClose="onEditClose" :data="data" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import PermissionNew from "@/components/PermissionNew";

export default {
    name: "PermissionDetail",
    components: {
        PermissionNew
    },
    props: {
        data: Object,
        show: { default: false },
        onClose: Function
    },
    data() {
        return {
            settings: null,
            processing: false,
            showEdit: false
        };
    },
    watch: {
        data(newData) {
            if (newData && newData.permission_level_id) {
                this.loadData();
            }
        }
    },
    mounted() {
        if (this.data && this.data.permission_level_id) {
            this.loadData();
        }
    },
    computed: {
        title() {
            return `${this.data.display_name || this.data.email}`;
        },
        permissions() {
            let permissions = [];
            for (let name in this.settings) {
                let _settings = [];
                let _sets = this.settings[name];
                for (let _set of _sets) {
                    let _setting = {
                        name: "setting",
                        value: []
                    };
                    for (let setting_name in _set) {
                        if (
                            setting_name != "id" &&
                            setting_name != "permission_level_id" &&
                            setting_name != "sub_permission_level_id" &&
                            setting_name != "code" &&
                            setting_name != "name"
                        ) {
                            _setting.value.push({
                                name: setting_name,
                                value: _set[setting_name] == 1
                            });
                        } else if (setting_name == "sub_permission_level_id") {
                            _setting.name = _set["name"];
                        }
                    }
                    if (_setting.value.length == 0) {
                        _setting.value.push({
                            name: `assigned`,
                            value: false
                        });
                    }

                    _settings.push(_setting);
                }

                permissions.push({
                    name,
                    value: _settings
                });
            }
            return permissions;
        }
    },
    methods: {
        ...mapActions(["request", "getError"]),
        beforeClose(done = () => {}) {
            done();
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
        },
        loadData() {
            let ctrl = this;
            if (ctrl.data.disabled) {
                return;
            }
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `permission/level/${ctrl.data.permission_level_id}/settings`
            })
                .then(({ data = {} }) => {
                    ctrl.settings = data;
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "PERMISSION_ERROR",
                        message: "Get permission details Failed"
                    }).then(ctrl.$notify);
                    ctrl.onClose();
                })
                .finally(() => {
                    ctrl.processing = false;
                });
        },
        onDelete() {
            let ctrl = this;
            ctrl.$confirm(
                "This permission will be removed permanently from user, Do you wish to continue?",
                "Remove permission",
                {
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    ctrl.processing = true;
                    ctrl.request({
                        method: "DELETE",
                        endpoint: `permission/${ctrl.data.id}`
                    })
                        .then(() => {
                            this.$message({
                                message: "Permission has been deleted",
                                type: "success"
                            });
                            ctrl.onCancelClick(true);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "PERMISSION_ERROR",
                                message: "Disable Permission Failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        },
        onEditClick() {
            this.showEdit = true;
        },
        onEditClose(reload = false) {
            this.showEdit = false;
            if (reload == true) {
                this.loadData();
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.permission-detail-item {
    display: flex;
    line-height: 26px;
    border-bottom: 1px solid #ccc;
}
.permission-detail-form-settings {
    border: 1px solid #ccc;
}
.permission-detail-item .title {
    width: 200px;
    text-align: right;
    background-color: rgba(0, 0, 0, 0.1);
    border-right: 1px solid #ccc;
}

.permission-detail-item .title span {
    padding: 0 8px;
}
.permission-detail-item .value {
    flex: 1;
}
.permission-detail-item .value span {
    padding: 0 8px;
}

.permission-detail-item:last-child {
    border-bottom: none;
}
</style>
